module.exports = __webpack_public_path__ + "assets/img/icon_User.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_User.png
// module id = 274
// module chunks = 0